export enum AppName {
  CAMPMINDER = 'camp_minder',
  SHARPSPRING = 'sharp_spring',
  CAMPER_MACHINE = 'sharp_spring/camper_machine',
  GOOGLE_SHEET = 'google_sheets',
  SCHOOL_BUS_MANAGER = 'school_bus_manager',
  HUBSPOT = 'hubspot',
  MAIL_CHIMP = 'mailchimp',
  CONSTANT_CONTACT = 'constant_contact',
  BLACKBAUD = 'black_baud',
  CAMPBRAIN = 'camp_brain',
  TCS_CUSTOM = 'tcs_custom'
}

export enum AppComponentClassname {
  ACTIVE = `group bg-foreground h-[190px] w-[203px] rounded-md flex flex-col 
    items-center justify-end p-6 mr-6 mb-6 hover:cursor-pointer hover:border-2 hover:border-accent
    hover:bg-accent-background duration-100`,
  COMING_SOON = `bg-border h-[190px] w-[203px] rounded-md flex flex-col 
    items-center justify-end p-6 mr-6 mb-6`,
  ACTIVE_APP_NAME = `mt-6 font-semibold text-primary h-12 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`,
  COMING_SOON_APP_NAME = `mt-6 font-semibold text-secondary h-12 flex flex-row items-center 
    group-hover:text-accent group-hover:underline`
}

export enum GoogleSheetOptionType {
  DRIVE = 'Drive',
  SHEET = 'Sheet',
  TAB = 'Tab'
}

export enum GoogleSheetOption {
  TAB_NAME = 'tabName'
}
